(function () {
  var WRAPPER_CLASS = 'loop-card-upsell-header-text';
  var HEADER_SELECTOR = '.loop-card-upsell-header';

  function wrapUpsellHeaderText(header) {
    if (header.querySelector('.' + WRAPPER_CLASS)) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;

    while (header.firstChild) {
      wrapper.appendChild(header.firstChild);
    }

    header.appendChild(wrapper);
  }

  function processUpsellHeaders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headers =
      scope === document
        ? document.querySelectorAll(HEADER_SELECTOR)
        : scope.matches && scope.matches(HEADER_SELECTOR)
          ? [scope]
          : scope.querySelectorAll(HEADER_SELECTOR);

    for (var i = 0; i < headers.length; i++) {
      wrapUpsellHeaderText(headers[i]);
    }
  }

  function relocateNavigationBar() {
    var navBar =
      document.getElementById('loop-cp-nova-navigation-bar') ||
      document.querySelector('[data-loop-id="cpNovaNavigationBar"]');
    var headerTopRow =
      document.getElementById('loop-cp-nova-header-top-row') ||
      document.querySelector('[data-loop-id="cpNovaHeaderTopRow"]');

    if (!navBar || !headerTopRow || !headerTopRow.parentNode) {
      return;
    }

    if (
      navBar.parentNode === headerTopRow.parentNode &&
      headerTopRow.nextElementSibling === navBar
    ) {
      return;
    }

    headerTopRow.insertAdjacentElement('afterend', navBar);
  }

  var UPCOMING_DELIVERY_ROW_CLASS = 'lr-upcoming-delivery-banner-row';
  var UPCOMING_DELIVERY_BANNER_ID = 'loop-cp-nova-upcoming-delivery-banner';
  var UPCOMING_DELIVERY_CUSTOM_SLOT_ID = 'loop--custom--xqmgdv';

  function wrapUpcomingDeliveryBannerRow() {
    var banner = document.getElementById(UPCOMING_DELIVERY_BANNER_ID);
    var customSlot = document.getElementById(UPCOMING_DELIVERY_CUSTOM_SLOT_ID);
    if (!banner || !customSlot) {
      return;
    }

    var rowWrapper = banner.closest('.' + UPCOMING_DELIVERY_ROW_CLASS);
    if (rowWrapper && rowWrapper.contains(customSlot)) {
      return;
    }

    var parent = banner.parentNode;
    if (!parent) {
      return;
    }

    rowWrapper = document.createElement('div');
    rowWrapper.className = UPCOMING_DELIVERY_ROW_CLASS;
    parent.insertBefore(rowWrapper, banner);
    rowWrapper.appendChild(banner);
    rowWrapper.appendChild(customSlot);
  }

  var loyaltyClickLock = false;

  function getOriginalLoopLoyaltyButton() {
    var insideRewards = document.querySelector(
      '.loop-nova-loyalty-rewards .loop-loyalty-btn, .loop-nova-loyalty-rewards button'
    );
    if (insideRewards && !insideRewards.classList.contains('larineco-rewards-card')) {
      return insideRewards;
    }

    var loyaltyClassBtn = document.querySelector(
      'button.loop-loyalty-btn:not(.larineco-rewards-card)'
    );
    if (loyaltyClassBtn) {
      return loyaltyClassBtn;
    }

    var allBtns = document.querySelectorAll('#loop-loyalty-btn, .loop-loyalty-btn');
    for (var i = 0; i < allBtns.length; i++) {
      var b = allBtns[i];
      if (
        !b.classList.contains('larineco-rewards-card') &&
        !b.closest('.larineco-rewards-card-shell')
      ) {
        return b;
      }
    }

    return null;
  }

  function triggerLoopLoyaltyDrawer() {
    if (loyaltyClickLock) {
      return;
    }

    var originalBtn = getOriginalLoopLoyaltyButton();
    if (!originalBtn) {
      return;
    }

    loyaltyClickLock = true;
    try {
      if (typeof originalBtn.click === 'function') {
        originalBtn.click();
      }
      var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      originalBtn.dispatchEvent(evt);
    } finally {
      setTimeout(function () {
        loyaltyClickLock = false;
      }, 300);
    }
  }

  var DOLLARS_PER_POINT = 0.02;

  function parsePoints(raw) {
    if (raw == null) return 0;
    var cleaned = String(raw).replace(/,/g, '').replace(/[^\d.-]/g, '');
    if (!cleaned || cleaned === '-' || cleaned === '.') return 0;
    var val = Number(cleaned);
    return isFinite(val) && val >= 0 ? val : 0;
  }

  function updateLarinecoRewardsBalances() {
    var cards = document.querySelectorAll('.larineco-rewards-card');
    if (!cards.length) return;

    var originalLoopBtn = getOriginalLoopLoyaltyButton();
    var buttonPoints = null;
    if (originalLoopBtn) {
      var m = String(originalLoopBtn.textContent || '').match(/([\d,]+)\s*(?:Loyalty\s*)?(?:points|pts)/i);
      if (m) {
        buttonPoints = parsePoints(m[1]);
      }
    }

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var pointsNode = card.querySelector('.larineco-rewards-card__points');
      var dollarsNode = card.querySelector('.larineco-rewards-card__dollars');
      if (!dollarsNode) {
        var balanceNode = card.querySelector('.larineco-rewards-card__balance');
        if (balanceNode) {
          dollarsNode = document.createElement('span');
          dollarsNode.className = 'larineco-rewards-card__dollars';
          balanceNode.appendChild(dollarsNode);
        } else {
          continue;
        }
      }

      var points = 0;
      if (pointsNode) {
        var dataPts = pointsNode.getAttribute('data-bubblehouse-points');
        if (dataPts && dataPts.indexOf('{{') === -1) {
          points = parsePoints(dataPts);
        } else if (pointsNode.textContent && pointsNode.textContent.indexOf('{{') === -1) {
          points = parsePoints(pointsNode.textContent.replace(/\s*pts\s*$/i, ''));
        }
      }

      if (!points && buttonPoints != null) {
        points = buttonPoints;
        if (pointsNode && (pointsNode.textContent.indexOf('{{') !== -1 || !pointsNode.textContent.trim())) {
          pointsNode.textContent = points + ' pts';
        }
      }

      dollarsNode.textContent = '$' + (points * DOLLARS_PER_POINT).toFixed(2);
    }
  }

  function sanitizeLogoutNavTab() {
    var nav = document.querySelector('#loop-cp-nova-navigation-bar .loop-nova-nav');
    if (!nav) return;

    var tabs = nav.querySelectorAll('.loop-nova-nav-tab');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var label = tab.querySelector('.loop-nova-nav-label');
      var isLogout =
        (label && label.textContent.trim().toLowerCase() === 'logout') ||
        Boolean(tab.querySelector('svg[viewBox*="47"]'));

      if (isLogout) {
        tab.classList.remove('loop-nova-nav-tab-active');
        tab.removeAttribute('aria-current');
      }
    }
  }

  function handleLogoutTabClick(event) {
    var tab = event.target.closest('#loop-cp-nova-navigation-bar .loop-nova-nav-tab');
    if (!tab) return;

    var label = tab.querySelector('.loop-nova-nav-label');
    var isLogout =
      (label && label.textContent.trim().toLowerCase() === 'logout') ||
      Boolean(tab.querySelector('svg[viewBox*="47"]'));

    if (isLogout) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = '/logout';
    }
  }

  document.addEventListener('click', handleLogoutTabClick, true);

  function handleRewardsCardClick(event) {
    var card = event.target.closest('.larineco-rewards-card');
    if (!card) {
      return;
    }

    event.preventDefault();
    triggerLoopLoyaltyDrawer();
  }

  function formatManageThumbMore() {
    var moreEls = document.querySelectorAll('.loop-nova-manage-thumb-more');
    for (var i = 0; i < moreEls.length; i++) {
      var el = moreEls[i];
      var match = el.textContent.match(/(\+\d+)/);
      if (match && el.textContent.trim() !== match[1]) {
        el.textContent = match[1];
      }
    }
  }

  function formatLineActionButtons() {
    var swapBtns = document.querySelectorAll('#loop-line-swap-btn');
    for (var i = 0; i < swapBtns.length; i++) {
      var swap = swapBtns[i];
      if (swap.classList.contains('loop-btn-primary')) {
        swap.classList.remove('loop-btn-primary');
        swap.classList.add('loop-btn-outline');
      }
    }

    var editBtns = document.querySelectorAll('#loop-line-edit-btn');
    for (var j = 0; j < editBtns.length; j++) {
      var edit = editBtns[j];
      if (edit.classList.contains('loop-btn-outline')) {
        edit.classList.remove('loop-btn-outline');
        edit.classList.add('loop-btn-primary');
      }
    }
  }

  function formatDiscountSummaryRow() {
    var rows = document.querySelectorAll(
      '.loop-nova-summary-row, .loop-nova-summary-row-toggle, button.loop-nova-summary-row'
    );
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var label = row.querySelector('.loop-nova-summary-label');
      var text = (label ? label.textContent : row.textContent) || '';
      if (/discount/i.test(text)) {
        row.classList.add('loop-discount-applied');
        var val = row.querySelector('.loop-nova-summary-value');
        if (val) {
          val.classList.add('loop-discount-applied-value');
        }
      }
    }

    var subRows = document.querySelectorAll('.loop-nova-collapse-inner .loop-nova-summary-row');
    for (var k = 0; k < subRows.length; k++) {
      var subVal = subRows[k].querySelector('.loop-nova-summary-value');
      if (subVal) {
        subVal.classList.add('loop-discount-applied-value');
      }
    }
  }

  function handleCancellationReasonClick(event) {
    var choice = event.target.closest(
      '#loop-cp-drawer-id-cancel-subscription-cancel-flow .loop-cancellation-flow-drawer-choice'
    );
    if (!choice || event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') {
      return;
    }
    var radio = choice.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.click();
    }
  }

  var CANCELLATION_FLOW_CUSTOM_CANCEL_BTN_ID = 'custom-cancel-subscription';
  var CANCELLATION_FLOW_PAUSE_DRAWER_ID = 'loop-cp-drawer-id-pause-subscription-popup';
  var CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_ID = 'lr-cancel-flow-pause-extra-btn';
  var CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_CLASS = 'loop-drawer-btn--extra';
  var CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_BOUND_ATTR = 'data-lr-cancel-flow-extra-bound';
  var CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_TEXT =
    "NO. I DON'T WANT TO PAUSE, I WANT TO CANCEL";
  var CANCELLATION_FLOW_CONFIRM_WRAP_ID = 'lr-cancel-confirm-wrap';
  var CANCELLATION_FLOW_CONFIRM_DRAWER_ID = 'lr-cancel-confirm-drawer';
  var CANCELLATION_FLOW_CONFIRM_HIDDEN_CLASS = 'lr-confirm-drawer-hidden';
  var cancellationFlowBypassTertiaryRedirect = false;

  function triggerElementClick(el) {
    if (!el) {
      return;
    }
    if (typeof el.click === 'function') {
      el.click();
    } else {
      el.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    }
  }

  function mountCancellationFlowConfirmDrawerOnLoad() {
    if (!document.body || document.getElementById(CANCELLATION_FLOW_CONFIRM_WRAP_ID)) {
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = 'loop ' + CANCELLATION_FLOW_CONFIRM_HIDDEN_CLASS;
    wrap.id = CANCELLATION_FLOW_CONFIRM_WRAP_ID;
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML =
      '<div class="loop-drawer" id="' +
      CANCELLATION_FLOW_CONFIRM_DRAWER_ID +
      '">' +
      '<div class="loop-drawer-content">' +
      '<div class="loop-drawer-header d-flex w-100 justify-content-between flex-row-reverse">' +
      '<button type="button" class="loop-btn loop-btn-underline loop-drawer-close-btn loop-cancel-btn">' +
      '<svg width="20" height="20" viewBox="70 1148 16 16" fill="currentColor" class="loop-svg-current-color" aria-hidden="true">' +
      '<path d="M78.0001 1156.85L76.0516 1158.78C75.9284 1158.91 75.789 1158.97 75.6334 1158.97C75.4779 1158.97 75.339 1158.91 75.2168 1158.78C75.0946 1158.66 75.0334 1158.52 75.0334 1158.37C75.0334 1158.21 75.0946 1158.07 75.2168 1157.95L77.1501 1156L75.2168 1154.07C75.0946 1153.94 75.0334 1153.81 75.0334 1153.65C75.0334 1153.49 75.0946 1153.36 75.2168 1153.23C75.339 1153.11 75.4779 1153.05 75.6334 1153.05C75.789 1153.05 75.9284 1153.11 76.0516 1153.23L78.0001 1155.17L79.9319 1153.23C80.0552 1153.11 80.1946 1153.05 80.3501 1153.05C80.5057 1153.05 80.6446 1153.11 80.7668 1153.23C80.889 1153.36 80.9501 1153.49 80.9501 1153.65C80.9501 1153.81 80.889 1153.94 80.7668 1154.07L78.8334 1156L80.7668 1157.95C80.889 1158.07 80.9501 1158.21 80.9501 1158.37C80.9501 1158.52 80.889 1158.66 80.7668 1158.78C80.6446 1158.91 80.5057 1158.97 80.3501 1158.97C80.1946 1158.97 80.0552 1158.91 79.9319 1158.78L78.0001 1156.85Z"></path>' +
      '</svg></button>' +
      '<div class="loop-h2"><span>Are you sure?</span></div></div>' +
      '<div class="loop-drawer-body">' +
      '<p class="lr-cancel-confirm-copy">Are you sure you want to cancel? This video will change your mind.</p>' +
      '<div class="lr-pause-video-wrap">' +
      '<video id="lr-cancel-confirm-video" class="lr-pause-drawer-video" src="https://cdn.shopify.com/videos/c/o/v/ac01075c7b5d444e8dc56b146176683c.mp4" preload="metadata" loop playsinline webkit-playsinline muted></video>' +
      '<button type="button" class="lr-pause-video-mute-btn is-muted" aria-label="Unmute video" title="Unmute">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M11 5L6 9H3v6h3l5 4V5z" fill="#fff"></path>' +
      '<path d="M16.5 9.5l5 5M21.5 9.5l-5 5" stroke="#fff" stroke-width="2" stroke-linecap="round"></path>' +
      '</svg></button></div></div>' +
      '<div class="loop-drawer-footer"><div class="d-flex flex-column">' +
      '<button type="button" class="loop-btn loop-btn-underline loop-btn-size-lg m-2 loop-drawer-btn lr-cancel-confirm-close-btn">Close</button>' +
      '<button type="button" class="loop-btn loop-btn-underline loop-btn-size-lg m-2 loop-drawer-btn loop-drawer-btn--extra lr-still-cancel-btn">No, I don\u2019t want to pause and still want to cancel</button>' +
      '</div></div></div></div>';

    document.body.appendChild(wrap);
  }

  function syncCancellationFlowConfirmVideoMuteUi() {
    var video = document.getElementById('lr-cancel-confirm-video');
    var muteBtn = document.querySelector(
      '#' + CANCELLATION_FLOW_CONFIRM_DRAWER_ID + ' .lr-pause-video-mute-btn'
    );
    if (!video || !muteBtn) {
      return;
    }

    var muted = video.muted;
    muteBtn.classList.toggle('is-muted', muted);
    muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    muteBtn.setAttribute('title', muted ? 'Unmute' : 'Mute');
  }

  function handleCancellationFlowPauseDrawerExtraButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    openCancellationFlowConfirmDrawer();
  }

  function bindCancellationFlowPauseDrawerExtraButton(extraBtn) {
    if (!extraBtn || extraBtn.getAttribute(CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_BOUND_ATTR) === 'true') {
      return;
    }
    extraBtn.setAttribute(CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_BOUND_ATTR, 'true');
    extraBtn.addEventListener('click', handleCancellationFlowPauseDrawerExtraButtonClick, true);
  }

  function getCancellationFlowPauseDrawerElement() {
    return document.getElementById(CANCELLATION_FLOW_PAUSE_DRAWER_ID);
  }

  function openCancellationFlowConfirmDrawer() {
    mountCancellationFlowConfirmDrawerOnLoad();

    var wrap = document.getElementById(CANCELLATION_FLOW_CONFIRM_WRAP_ID);
    var drawer = document.getElementById(CANCELLATION_FLOW_CONFIRM_DRAWER_ID);
    if (!wrap || !drawer) {
      return;
    }

    wrap.classList.remove(CANCELLATION_FLOW_CONFIRM_HIDDEN_CLASS);
    wrap.setAttribute('aria-hidden', 'false');
    drawer.classList.add('appear-done', 'enter-done');

    var pauseDrawer = document.getElementById(CANCELLATION_FLOW_PAUSE_DRAWER_ID);
    if (pauseDrawer) {
      pauseDrawer.classList.remove('enter-done');
    }

    var video = document.getElementById('lr-cancel-confirm-video');
    if (video) {
      video.muted = true;
      video.currentTime = 0;
      syncCancellationFlowConfirmVideoMuteUi();
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  function resetCancellationFlowLoopPortalScrollLock() {
    var overlays = document.querySelectorAll('.loop-drawer-overlay.enter-done');
    for (var i = 0; i < overlays.length; i++) {
      overlays[i].classList.remove('enter-done');
    }

    if (!document.body) {
      return;
    }

    var bodyOverflow = document.body.style.overflow;
    if (bodyOverflow === 'hidden' || bodyOverflow === 'clip') {
      document.body.style.removeProperty('overflow');
    }
  }

  function closeCancellationFlowConfirmDrawer() {
    var wrap = document.getElementById(CANCELLATION_FLOW_CONFIRM_WRAP_ID);
    var drawer = document.getElementById(CANCELLATION_FLOW_CONFIRM_DRAWER_ID);
    if (!wrap || !drawer) {
      return;
    }

    wrap.classList.add(CANCELLATION_FLOW_CONFIRM_HIDDEN_CLASS);
    wrap.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('appear-done', 'enter-done');

    var video = document.getElementById('lr-cancel-confirm-video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    resetCancellationFlowLoopPortalScrollLock();
  }

  function triggerCancellationFlowFooterTertiaryNativeClick() {
    var tertiaryBtn = document.getElementById('loop-nova-footer-tertiary-btn');
    if (!tertiaryBtn) {
      return;
    }

    cancellationFlowBypassTertiaryRedirect = true;
    try {
      triggerElementClick(tertiaryBtn);
    } finally {
      setTimeout(function () {
        cancellationFlowBypassTertiaryRedirect = false;
      }, 300);
    }
  }

  function injectCancellationFlowPauseDrawerExtraButton() {
    var pauseRoot = getCancellationFlowPauseDrawerElement();
    if (!pauseRoot) {
      return;
    }

    var existingExtraBtn = document.getElementById(CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_ID);
    if (existingExtraBtn) {
      bindCancellationFlowPauseDrawerExtraButton(existingExtraBtn);
      return;
    }

    var footer = pauseRoot.querySelector('.loop-drawer-footer');
    if (!footer) {
      return;
    }

    var buttonRow =
      footer.querySelector('.d-flex.flex-column') || footer.querySelector('div');
    if (!buttonRow) {
      return;
    }

    var extraByClass = buttonRow.querySelector('.' + CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_CLASS);
    if (extraByClass) {
      if (!extraByClass.id) {
        extraByClass.id = CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_ID;
      }
      bindCancellationFlowPauseDrawerExtraButton(extraByClass);
      return;
    }

    var footerButtons = buttonRow.children;
    var buttonElements = [];
    for (var i = 0; i < footerButtons.length; i++) {
      if (footerButtons[i].tagName === 'BUTTON') {
        buttonElements.push(footerButtons[i]);
      }
    }
    if (buttonElements.length < 2) {
      return;
    }

    var extraBtn = document.createElement('button');
    extraBtn.type = 'button';
    extraBtn.id = CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_ID;
    extraBtn.className =
      'loop-btn loop-btn-underline loop-btn-size-lg m-2 loop-drawer-btn ' +
      CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_CLASS;
    extraBtn.textContent = CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_TEXT;

    buttonElements[1].insertAdjacentElement('afterend', extraBtn);
    bindCancellationFlowPauseDrawerExtraButton(extraBtn);
  }

  function handleCancellationFlowCustomCancelClick(event) {
    var customBtn = event.target.closest('#' + CANCELLATION_FLOW_CUSTOM_CANCEL_BTN_ID);
    if (!customBtn) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    triggerElementClick(document.getElementById('loop-nova-footer-tertiary-btn'));
  }

  function handleCancellationFlowFooterTertiaryClick(event) {
    if (cancellationFlowBypassTertiaryRedirect) {
      return;
    }

    var tertiaryBtn = event.target.closest('#loop-nova-footer-tertiary-btn');
    if (!tertiaryBtn) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var secondaryBtn = document.getElementById('loop-nova-footer-secondary-btn');
    triggerElementClick(secondaryBtn);
  }

  function handleCancellationFlowConfirmDrawerClick(event) {
    if (
      event.target.closest('#' + CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_ID) ||
      event.target.closest(
        '#' + CANCELLATION_FLOW_PAUSE_DRAWER_ID + ' .' + CANCELLATION_FLOW_PAUSE_DRAWER_EXTRA_BTN_CLASS
      )
    ) {
      handleCancellationFlowPauseDrawerExtraButtonClick(event);
      return;
    }

    var confirmDrawer = event.target.closest('#' + CANCELLATION_FLOW_CONFIRM_DRAWER_ID);
    if (!confirmDrawer) {
      return;
    }

    if (event.target.closest('.lr-pause-video-mute-btn')) {
      event.preventDefault();
      var video = document.getElementById('lr-cancel-confirm-video');
      if (video) {
        video.muted = !video.muted;
        syncCancellationFlowConfirmVideoMuteUi();
      }
      return;
    }

    if (
      event.target.closest('.loop-drawer-close-btn') ||
      event.target.closest('.lr-cancel-confirm-close-btn')
    ) {
      event.preventDefault();
      closeCancellationFlowConfirmDrawer();
      return;
    }

    if (event.target.closest('.lr-still-cancel-btn')) {
      event.preventDefault();
      closeCancellationFlowConfirmDrawer();
      triggerCancellationFlowFooterTertiaryNativeClick();
    }
  }

  document.addEventListener('click', handleRewardsCardClick);
  document.addEventListener('click', handleCancellationReasonClick);
  document.addEventListener('click', handleCancellationFlowCustomCancelClick, true);
  document.addEventListener('click', handleCancellationFlowFooterTertiaryClick, true);
  document.addEventListener('click', handleCancellationFlowConfirmDrawerClick, true);

  function initLoopPortalEnhancements() {
    processUpsellHeaders(document);
    relocateNavigationBar();
    wrapUpcomingDeliveryBannerRow();
    updateLarinecoRewardsBalances();
    sanitizeLogoutNavTab();
    formatManageThumbMore();
    formatLineActionButtons();
    formatDiscountSummaryRow();
    injectCancellationFlowPauseDrawerExtraButton();

    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldCheckRelocate = false;

      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) {
            continue;
          }
          processUpsellHeaders(node);
          shouldCheckRelocate = true;
        }
      }

      if (shouldCheckRelocate) {
        relocateNavigationBar();
        wrapUpcomingDeliveryBannerRow();
        updateLarinecoRewardsBalances();
        sanitizeLogoutNavTab();
        formatManageThumbMore();
        formatLineActionButtons();
        formatDiscountSummaryRow();
        injectCancellationFlowPauseDrawerExtraButton();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootLoopPortalEnhancements() {
    mountCancellationFlowConfirmDrawerOnLoad();
    initLoopPortalEnhancements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLoopPortalEnhancements);
  } else {
    bootLoopPortalEnhancements();
  }
})();
